const React = require('react');
const IconDown = require('../../../icons/Down');
const Slot = require('./Slot');


module.exports = (props) => {
  return (
    <Slot
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <div className="layoutRow fhaS fvaC">
        <div className="mr15 f12 fw3 lh lts0em tc">{props.label}</div>
        <IconDown className="w20 rlv dn st st3<2:h"/>
      </div>
    </Slot>
  );
};
